module.exports = __webpack_public_path__ + "img/luckDraw_pop.49313489.png";